import { Chat } from '../../chatSlice';
import { apiGet, apiPost } from './apiUtils';
import { getCurrentISOString } from './timeUtils';

export const createTestChats = (): Chat[] => {

  return [
    {
      id: '1',
      title: 'Анализ крови пациента',
      lastMessageTime: getCurrentISOString(),
      createdAt: getCurrentISOString(),
      messages: [
        {
          sender: 'user',
          time: getCurrentISOString(),
          type: 'text',
          text: 'Добрый день! У меня есть результаты анализа крови, можете помочь их интерпретировать?',
        },
        {
          sender: 'ai',
          time: getCurrentISOString(),
          type: 'text',
          text: 'Конечно! Пожалуйста, поделитесь результатами анализов, и я помогу вам их интерпретировать.',
        },
        {
          sender: 'user',
          time: getCurrentISOString(),
          type: 'photo',
          text: 'https://main-cdn.sbermegamarket.ru/big1/hlr-system/-16/021/715/291/216/222/9/100045560712b0.jpg',
          title: 'Результаты ОАК',
        },
      ],
    },
    {
      id: '2',
      title: 'Консультация по ЭКГ',
      lastMessageTime: getCurrentISOString(),
      createdAt: getCurrentISOString(),
      messages: [
        {
          sender: 'user',
          time: getCurrentISOString(),
          type: 'text',
          text: 'Здравствуйте! Можете посмотреть на мою ЭКГ?',
        },
        {
          sender: 'ai',
          time: getCurrentISOString(),
          type: 'text',
          text: 'Да, конечно! Покажите, пожалуйста, результаты ЭКГ.',
        },
      ],
    },
    {
      id: '3',
      title: 'Вопросы по МРТ',
      lastMessageTime: getCurrentISOString(),
      createdAt: getCurrentISOString(),
      messages: [
        {
          sender: 'user',
          time: getCurrentISOString(),
          type: 'text',
          text: 'У меня есть вопросы по результатам МРТ головного мозга.',
        },
      ],
    },
  ];
};

export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export async function login(email: string, password: string): Promise<any | null> {
  // if (process.env.NODE_ENV === 'development') {
  //   // Фейковый ответ для разработки
  //   if (email === 'test@test.com' && password === '123456') {
  //     return { token: 'fake-token' };
  //   } else {
  //     throw new Error('Неверный email или пароль');
  //   }
  // }
  const response = await apiPost('/auth/login/', { email, password });
  if (!response.ok) {
    // Проверяем, является ли это ошибкой истекшего сеанса
    if (response.status === 401) {
      try {
        const errorData = await response.json();
        if (errorData.error === 'session_expired') {
          console.log('Сессия истекла при попытке входа');
          return null;
        }
      } catch {
        // Если не удалось распарсить JSON, считаем обычной ошибкой 401
      }
    }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Ошибка авторизации');
  }
  // В режиме cookie сервер устанавливает HTTP-only куки; тело ответа может содержать лишь сервисные поля
  return response.json().catch(() => ({}));
}

export async function getMe(): Promise<any | null> {
  // if (process.env.NODE_ENV === 'development') {
  //   // Фейковый профиль для разработки
  //   return {
  //     email: 'test@test.com',
  //     phone_number: '+79999999999',
  //     first_name: 'Иван',
  //     last_name: 'Иванов',
  //     id: 1,
  //     role_name: 'Врач',
  //     role_id: 1,
  //     specialty: 'rentgenolog',
  //   };
  // }
  const response = await apiGet('/auth/me/');
  if (!response.ok) {
    // Проверяем, является ли это ошибкой истекшего сеанса
    if (response.status === 401) {
      try {
        const errorData = await response.json();
        if (errorData.error === 'session_expired') {
          console.log('Сессия истекла при получении профиля');
          return null;
        }
      } catch {
        // Если не удалось распарсить JSON, считаем обычной ошибкой 401
      }
    }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Ошибка получения профиля');
  }
  return response.json();
}

export async function logout(): Promise<boolean | null> {
  try {
    const response = await apiPost('/auth/logout');
    if (!response.ok) {
      // Проверяем, является ли это ошибкой истекшего сеанса
      if (response.status === 401) {
        try {
          const errorData = await response.json();
          if (errorData.error === 'session_expired') {
            console.log('Сессия истекла при попытке выхода');
            return null;
          }
        } catch {
          // Если не удалось распарсить JSON, считаем обычной ошибкой 401
        }
      }
      console.warn('Ошибка при выходе из системы, но продолжаем');
    }
    return true;
  } catch (error) {
    console.warn('Ошибка при выходе из системы:', error);
    return true; // Всё равно считаем logout успешным
  }
}

export const createChatOnServer = async (title: string, firstMessage?: any): Promise<Chat | null> => {
  try {
    // Создаем чат на сервере
    const response = await apiPost('/chats/', {
      title: title,
      description: '',
    });

    let chatId = `chat_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`; // fallback ID

    if (response.ok) {
      const result = await response.json();
      chatId = result.id?.toString() || chatId;
    } else if (response.status === 401) {
      // Проверяем, является ли это ошибкой истекшего сеанса
      try {
        const errorData = await response.json();
        if (errorData.error === 'session_expired') {
          console.log('Сессия истекла при создании чата');
          // Возвращаем null, чтобы вызывающий код мог обработать истекший сеанс
          return null;
        }
      } catch {
        // Если не удалось распарсить JSON, считаем обычной ошибкой 401
      }
      console.warn('Ошибка создания чата на сервере, создаем с локальным ID');
    } else {
      console.warn('Ошибка создания чата на сервере, создаем с локальным ID');
    }

    // Создаем объект чата
    const newChat: Chat = {
      id: chatId,
      title: title,
      lastMessageTime: firstMessage?.time || getCurrentISOString(),
      messages: firstMessage ? [firstMessage] : [],
      createdAt: new Date().toISOString(),
    };

    return newChat;
  } catch (error) {
    console.error('Ошибка при создании чата:', error);

    // Fallback: создаем локальный чат
    const fallbackChat: Chat = {
      id: `chat_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      title: title,
      lastMessageTime: firstMessage?.time || new Date().toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
      }),
      messages: firstMessage ? [firstMessage] : [],
      createdAt: new Date().toISOString(),
    };

    return fallbackChat;
  }
}; 